import React from 'react';
import { Link } from 'react-router';
import { Button, Icon } from 'semantic-ui-react';


const AccessDenied = () => {

    document.title = "Access Denied";
    return (
      <div>
          <div id="view-header-section">
              <h1 className="view-title">Access Denied.</h1>
              <p className="white-text">Sorry, you don't have access to this.</p>
          </div>
          <br/><br/>
          <Button as={Link} to="/" className="back-to-dash">
              <Icon name="left arrow"/>
              Back to Dashboard
          </Button>
      </div>
    );
};

export default AccessDenied;



// WEBPACK FOOTER //
// ./src/components/views/AccessDenied.js